module.exports = __webpack_public_path__ + "7dbb26374b42ccf972e31e726305d0e9.pdf";